export default "__VITE_ASSET__E_XVIW9i__"